import React from 'react';
import PropTypes from 'prop-types';
import { rem } from 'polished';
import styled from 'styled-components';
import { __, formatPrice } from '../../../../Utils';
import { connect } from '../../../../Store';
import BaseList from '../../BaseList';
import IconTd from '../../../../Components/ReusableComponents/IconTd';

const P = styled.p`
  margin: 0;
  padding: 0 ${rem(10)};
  font-size: ${rem(12)};
  height: ${rem(32)};
  display: flex;
  align-items: center;
`;

class ProductItems extends BaseList {
  constructor(props) {
    super(props);

    this.state = {
      ...this.state,
      title: __('Riadky faktúry'),
      notFoundMessage: __('Ľutujeme riadky sa nenašli'),
      isProduct: true,
      showFilter: false,
      showPager: false,
      showHeader: false,
      sorter: 'line_no',
      displayedColumns: {},
      buttonsSwitch: [],
      defaultFilter: [
        {
          id: 'type',
          values: ['invoices'],
        },
      ],
    };
  }

  componentDidMount() {
    if (this.props.rows) {
      this.setState({
        tableItems: this.props.rows,
        loading: false,
      });
    }

    this.init();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.rows && nextProps.rows.length !== this.props.rows) {
      this.setState({
        tableItems: this.props.rows,
        loading: false,
      });
    }
  }

  init() {
    this.setTableHeight();
    this.saveActualData(1, 0, null, [], null);
  }

  setTableHeight() {
    if (this.pager && this.mainWrapper && this.segment) {
      const tableHeight = window.innerHeight - 600;

      this.setState({ tableHeight });
    }
  }

  onRowClicked(index) {
    const id = this.state.tableItems[index].No;

    if (id && id.length > 1) {
      this.props.history.push(`/buy/products/${id}`);
    }
  }

  createColumns() {
    const result = [
      {
        accessor: 'No',
        Header: () => <IconTd>{__('Id')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },

      {
        accessor: 'Description',
        Header: () => <IconTd>{__('Názov produktu')}</IconTd>,
        minWidth: 250,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },

      {
        accessor: 'Unit_of_Measure_Code',
        Header: () => <IconTd>{__('Merná jednotka')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },

      {
        accessor: 'Unit_Price',
        Header: () => <IconTd>{__('Cena za kus')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatPrice({
                amount: props.value,
                currency: this.props.firm === 'SK' ? 'EUR' : 'Kč',
              })}
            </P>
          );
        },
      },

      {
        accessor: 'Line_Discount_Percent',
        Header: () => <IconTd>{__('Zľava')}</IconTd>,
        Cell: props => {
          return <P>{`${props.value}%`}</P>;
        },
      },

      {
        accessor: 'Unit_Price',
        Header: () => <IconTd>{__('Cena za kus po zľave')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatPrice({
                currency: this.props.firm === 'SK' ? 'EUR' : 'Kč',
                amount:
                  props.value -
                  props.value *
                    (Number(props.original.Line_Discount_Percent) / 100),
              })}
            </P>
          );
        },
      },

      {
        accessor: 'Quantity',
        Header: () => <IconTd>{__('Počet kusov')}</IconTd>,
        Cell: props => {
          return <P>{props.value}</P>;
        },
      },

      {
        accessor: 'Line_Amount',
        Header: () => <IconTd>{__('Cena spolu')}</IconTd>,
        Cell: props => {
          return (
            <P>
              {formatPrice({
                amount: props.value,
                currency: this.props.firm === 'SK' ? 'EUR' : 'Kč',
              })}
            </P>
          );
        },
      },
    ];

    return result;
  }

  render() {
    return super.render();
  }
}

ProductItems.propTypes = {
  history: PropTypes.shape({
    push: PropTypes.func,
  }).isRequired,
};

const mapStateToProps = state => {
  return {
    ...state,
  };
};

export default connect(mapStateToProps)(ProductItems);



// WEBPACK FOOTER //
// ./src/Containers/Shop/Orders/Rows/index.jsx